import { Box, CircularProgress } from '@mui/material';

interface CenteredLoadingProps {
  py?: number;
  size?: number;
}

export const CenteredLoading: React.FC<CenteredLoadingProps> = ({ py = 6, size }) => (
  <Box display='flex' justifyContent='center' py={py}>
    <CircularProgress size={size} />
  </Box>
);
